export default __webpack_public_path__ + "static/media/logo-opensky-no-padding.4950b709.png";